import { ExplorerProjectPage } from 'features/explorer/ExplorerProjectPage';
import { useNavigateToOnboarding } from 'features/onboardingJourney/useNavigateToOnboarding';

export const ExplorerPage = () => {
  useNavigateToOnboarding();

  // No multi-project selection for now
  return <ExplorerProjectPage />;
};
